import { render, staticRenderFns } from "./color-panel.vue?vue&type=template&id=6c3b6a2e&"
import script from "./color-panel.vue?vue&type=script&lang=js&"
export * from "./color-panel.vue?vue&type=script&lang=js&"
import style0 from "./color-panel.vue?vue&type=style&index=0&id=6c3b6a2e&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports